import { render, staticRenderFns } from "./DataAnnotationSection.vue?vue&type=template&id=2db08112&scoped=true&"
import script from "./DataAnnotationSection.vue?vue&type=script&lang=js&"
export * from "./DataAnnotationSection.vue?vue&type=script&lang=js&"
import style0 from "./DataAnnotationSection.vue?vue&type=style&index=0&id=2db08112&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db08112",
  null
  
)

export default component.exports